const DEFAULT_CURRENCY_FRACTION_DIGITS = 2;

// The ISO 4217 minor-unit count of a currency (EUR 2, JPY 0), the table the BE's money type uses
// as well. An unknown code falls back to the common two digits.
export const getCurrencyFractionDigits = (currency: string): number => {
  try {
    return (
      new Intl.NumberFormat('en', {style: 'currency', currency}).resolvedOptions()
        .maximumFractionDigits ?? DEFAULT_CURRENCY_FRACTION_DIGITS
    );
  } catch {
    return DEFAULT_CURRENCY_FRACTION_DIGITS;
  }
};
